export enum PayoutPeriod {
  Year2024 = "2024"
}

export enum AssociatedResourceType {
  Invoice = "Invoice"
}
